import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EncodingService {
  static encodingB64(data: string): string {
    return window.btoa(data);
  }

  static decodingB64(data: string): string {
    return window.atob(data);
  }
}
